import { render, staticRenderFns } from "./nav.vue?vue&type=template&id=65146470&scoped=true&"
import script from "./nav.vue?vue&type=script&lang=js&"
export * from "./nav.vue?vue&type=script&lang=js&"
import style0 from "./nav.vue?vue&type=style&index=0&id=65146470&prod&scoped=true&lang=scss&"
import style1 from "./nav.vue?vue&type=style&index=1&id=65146470&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65146470",
  null
  
)

export default component.exports